export const DEFAULT_PAGE_SIZE = 3;

export const MEDIA_CATEGORY = {
    COVER: "COVER",
    INTERIOR: "INTERIOR",
    EXTERIOR: "EXTERIOR"
}

export const MEDIA_URL_TYPE = {
    ORIGIN: "ORIGINURL"
}

export const MEDIA_TYPE = {
    PHOTO: "PHOTO"
}

export const MEDIA_ACTION = {
    INSERT: "INSERT",
    UPDATE: "UPDATE",
    UNCHANGE: "UNCHANGE",
    REMOVE: "REMOVE"
}

export const NONE_DISPLAY = "none";
export const DEFAULT_IMG_URL = "https://qph.fs.quoracdn.net/main-qimg-b20ae10c8071ce30647062fb09f52708";